<template>
<div class="hs-container">
    <div class="handle-box">
        <div class="handle-left">
            <div class="search-left">
                <!-- @submit.native.prevent 阻止整个页面路由刷新 -->
                <el-form :inline="true" :model="ruleForm" class="demo-form-inline" @submit.native.prevent>
                    <el-form-item label="商户：">
                        <el-select v-model="ruleForm.company_id" placeholder="请选择隶属商户" class="handle-input mr10" filterable clearable>
                            <el-option v-for="(item, index) in hotelList" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="信息类型：">
                        <el-select v-model="ruleForm.news_type" filterable clearable class="formSelect" placeholder="请选择信息类型">
                            <el-option v-for="item in newsTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="成单时间：">
                        <el-date-picker class="daterange mr10" v-model="ruleForm.create_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交时间：">
                        <el-date-picker class="daterange mr10" v-model="ruleForm.event_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" native-type="submit" @click="getSearch">搜索</el-button>
                        <el-button type="primary" @click="exportExcel">导出</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
    <!-- 搜索E -->
    <el-table id="out-table" :data="tableData" :height="height" border class="table" ref="multipleTable" header-cell-class-name="table-header" v-loading="loading">
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="company.title" label="商户名称" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="user.realname" label="商户销售" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fullname" label="客户姓名" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="mobile" label="手机号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tag" label="信息类型" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                {{dictionary.getPickerTitle('news_type', scope.row.news_type)}}
            </template>
        </el-table-column>
        <el-table-column prop="totals" show-overflow-tooltip label="订单总额"></el-table-column>
        <el-table-column prop="event_date" label="婚期" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="table_price" label="餐标" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="banquet_type" label="宴会类型" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                <div v-if="scope.row.banquet_type==1">午宴</div>
                <div v-if="scope.row.banquet_type==2">晚宴</div>
                <div v-if="scope.row.banquet_type==3">全天</div>
            </template>
        </el-table-column>
        <el-table-column prop="allocate.department.title" label="分配人部门" align="center" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="allocate.user.realname" label="分配人" align="center" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="create_time" width="200" label="创建时间" align="center"> </el-table-column>
    </el-table>
    <!-- 底部S -->
    <div class="footer-box">
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
    </div>
    <!-- 底部E -->
</div>
</template>

<script>
import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import dictionary from '@/utils/dictionary.js';
import {
    checkDataAuth
} from '@/utils/common.js';
const ruleForm = {
    company_id: "",
    news_type: "",
    create_time: "",
    event_time: "",
};
export default {
    name: 'basetable',
    data() {
        return {
            loading: false,
            height: 660,
            departmentTree: [],
            tableData: [],
            ruleForm: Object.assign({}, ruleForm),
            staffList: [],
            dialogVisible: false,
            touchVisible: false,
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 1
            },
            visitList: [],
            touchList: [],
            isPagination: {},
            pickerOptions: {
                shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },

        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    computed: {
        hotelList: function () {
            return dictionary.getPicker('hotel');
        },
        newsTypeList: function () {
            return dictionary.getPicker('news_type');
        },

    },
    created() {
        this.height = window.innerHeight * 0.75;

        this.getTableData();

        // 验证搜索权限
        let _this = this;
        checkDataAuth().then((res) => {
            _this.auth = res;
        })
    },
    methods: {
        getTouch(e) {
            let _this = this;
            _this.touchList = []
            let url = '/api/statistics.lookup/lookup';
            _this.$post(url, {
                allocate_id: e.id,
                user_id: e.user_id,
            }).then(res => {
                _this.touchList = res.data

            })
            _this.touchVisible = true
        },
        getVisit(e) {
            let _this = this;
            _this.visitList = []
            let url = '/api/statistics.lookup/visit';
            this.$post(url, {
                member_id: e.member_id,
                user_id: e.user_id,
            }).then(res => {
                _this.visitList = res.data

            })
            this.dialogVisible = true
        },
        handleClose() {
            this.dialogVisible = false
            this.touchVisible = false
        },
        changeHandler() {
            this.pagination.page = 1;
            this.getTableData();
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getTableData() {
            let that = this;
            let url = '/api/merchant.order/index';
            let ruleForm = that.ruleForm;
            ruleForm['pagination'] = this.pagination;
            this.$post(url, ruleForm).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = response.data.pagination;
                that.loading = false;
            });
        },
        // 重置
        resetFn() {
            this.ruleForm.department_id = '';
            this.ruleForm.user_id = '';
            this.ruleForm.source_id = '';
            this.ruleForm.account_city_id = '';
            this.ruleForm.account_id = '';
            this.ruleForm.hotel_id = '';
            this.$refs.cascader.$refs.panel.clearCheckedNodes(); //清空部门查找 级联选择器选择的节点
        },
        exportExcel() {
            let _this = this;
            let url = '/api/merchant.order/download';
            let options = _this.ruleForm;;
            this.$post(url, options).then(res => {
                if (res.code == '200') {
                    let link = document.createElement('a');
                    link.href = res.data.url;
                    link.click();

                }
            })

        },
        // 触发搜索按钮
        getSearch() {
            let _this = this;
            _this.getTableData();
            _this.pagination.page = 1;
        },

        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取Picker
        getPicker() {
            let url = '/api/statistics.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.companyList = response.data.companyList;
                that.cooperationModeList = response.data.cooperationModeList;
                that.sourceList = response.data.sourceList;
                that.hotelList = response.data.hotelList;
            });
        },
        handleCascader(e) {
            let last = e.length - 1;
            this.ruleForm.department_id = e[last];
            let that = this;
            let url = '/api/ucenter.user/getDepartmentUserList';
            let ruleForm = {
                id: e[last]
            };
            // 添加或编辑客资信息
            that.$post(url, ruleForm).then(function (response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.staffList = response.data.list;
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');
</style>
